import {Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import './playlist-state-modal.scss';
import {Modal} from '../../modal/modal';
import {translations} from '../../../i18n/translations';

type PlaylistStateModalProps = {
  open: boolean;
  playlistName: string;
  state: 'enable' | 'disable';
  userName: string;
  onClose: () => void;
  onConfirm: () => void;
};

export const PlaylistItemStateModal = ({
  open,
  playlistName,
  state,
  userName,
  onClose,
  onConfirm,
}: PlaylistStateModalProps) => {
  const {t} = useTranslation();

  return (
    <Modal
      className="playlists-state-modal"
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      preventCloseClick
      actions={[
        {
          label: t(translations.modal.cancel),
          type: 'destructive',
          onClick: onClose,
        },
        {
          label: t(translations.modal.confirm),
          type: 'nondestructive',
          onClick: onConfirm,
        },
      ]}
    >
      <Stack>
        <Typography className="title">
          {t(translations.user_playlist_items[`${state}_item_dialog_title`], {
            name: playlistName,
          })}
        </Typography>
        <Typography className="subtitle">
          {t(translations.user_playlist_items[`${state}_item_dialog_message`], {
            name: userName,
          })}
        </Typography>
      </Stack>
    </Modal>
  );
};
